module.exports = "<!-- Row Tree View -->\r\n<div class=\"treeview\" id=\"tree\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/treeView/treeView.component.html
// module id = ../../../../../src/app/helpers/components/treeView/treeView.component.html
// module chunks = main